import router from "page";
import Home from "../pages/home/Home.svelte";
import About from "../pages/about/About.svelte";
import "../pages/about/Roadmap.svelte";
import "../pages/nft/NFTMint.svelte";
import "../pages/nft/NFTInfo.svelte";
import "../pages/gallery/Gallery.svelte";
import "../pages/market/Market.svelte";
import Presale from "../pages/token/Presale.svelte";
import "../pages/token/Tokenomics.svelte";
import "../pages/wallet/Wallet.svelte";
import Staking from "../pages/staking/Staking.svelte";
import "../pages/community/Community.svelte";
import "../pages/community/Media.svelte";
import PrivacyPolicy from "../pages/about/PrivacyPolicy.svelte";
import { writable } from "svelte/store";
export let currentPage = writable(Home);
export let currentDoeId = writable(1);
const getId = (ctx, next) => {
    try {
        currentDoeId.set(parseInt(ctx.params.id));
    }
    catch (_a) {
        currentDoeId.set(1);
    }
    next();
};
const getReferrals = async (ctx, next) => {
    next();
    try {
        const ref = new URLSearchParams(window.location.search).get("ref");
        if (ref)
            localStorage.setItem("__doe_ref", ref.toLowerCase());
    }
    catch (err) {
        console.error("referrals: router:", err);
    }
};
router('/', getReferrals, () => currentPage.set(Home));
router('/about', getReferrals, () => currentPage.set(About));
router('/staking', () => currentPage.set(Staking));
router('/presale', () => currentPage.set(Presale));
router('/privacypolicy', () => currentPage.set(PrivacyPolicy));
router.start();
